// extracted by mini-css-extract-plugin
export var mintNft = "MintNFT_mintNft__bjq0C";
export var nav = "MintNFT_nav__Y+vb9";
export var tabContent = "MintNFT_tabContent__l1AHc";
export var rotate = "MintNFT_rotate__XxZ8G";
export var dotty = "MintNFT_dotty__4+off";